<template>
  <div class="p-20px pt-42px">
    <div class="mb-20px">
      <div class="flex items-center justify-between">
        <div class="w-35px h-35px" @click="goBack">
          <img src="@/assets/images/mine/left.webp" alt="" class="w-full h-full">
        </div>
        <div class="color-#fff text-16px font-700">
          {{ t('settings.title') }}
        </div>
        <div class="w-35px h-35px">

        </div>
      </div>
    </div>
    <!-- 设置列表 -->
    <div class="settings-list">
      <div class="setting-item border-bottom mb-20px!" @click="goEditProfile">
        <div class="left relative">
          <img src="@/assets/images/mine/edit_profile.svg" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.editProfile') }}</span>
          <span class="dot" v-if="!isEditInfo"></span>
        </div>
      </div>
      <!-- <div class="setting-item">
        <div class="left">
          <img src="@/assets/images/setting/notification.svg" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.systemNotification') }}</span>
        </div>
        <div class="w-28px h-12px flex item-centers ml-auto" @click="handleNotification">
          <img v-if="!isNotification" src="@/assets/images/setting/kai.svg" class="w-full h-full"></img>
        </div>
      </div> -->
      <div class="setting-item mb-1px!  border-top" @click="handleDiscord">
        <div class="left">
          <img src="@/assets/images/setting/discord.svg" alt="" class="w-20px mr-12px">
          <span class="text">Contact Us</span>
        </div>
      </div>
      <div class="setting-item mb-1px!" @click="goFAQ">
        <div class="left">
          <img src="@/assets/images/mine/fqa.svg" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.faq') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>
      <div class="setting-item mb-1px!" @click="openTerms">
        <div class="left">
          <img src="@/assets/images/mine/use.svg" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.termsOfUse') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>

      <div class="setting-item mb-1px! border-bottom-1" @click="openPrivacy">
        <div class="left">
          <img src="@/assets/images/mine/privacy_olicy.svg" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.privacyPolicy') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>
      <div class="setting-item mt-20px! mb-1px! border-top" @click="handleAboutAccount">
        <div class="left">
          <img src="@/assets/images/home/account.webp" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.aboutAccount') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>
      <!-- <div class="setting-item" @click="clearCache">
        <div class="left">
          <img src="@/assets/images/mine/clean.svg" alt="" class="w-20px mr-12px"></img>
          <span class="text">{{ t('settings.clearCache') }}</span>
        </div>
      </div> -->
      <div class="setting-item mb-1px! border-bottom-1" @click="deleteAccount">
        <div class="left">
          <img src="@/assets/images/mine/delete.svg" alt="" class="w-20px mr-12px"></img>
          <span class="text">{{ t('settings.deleteAccount') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>

      <div class="setting-item mt-40px! border-bottom" @click="handleLogout">
        <div class="left">
          <img src="@/assets/images/mine/out.svg" alt="" class="w-20px mr-12px"></img>
          <span class="text">{{ t('settings.logOut') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>
    </div>
    <div class="color-#fff flex items-center justify-center fixed bottom-30px left-0 right-0">
      <div class="w-25px h-20px flex items-center justify-center">
        <img src="@/assets/images/home/version.webp" alt="" class="w-full h-full mr-12px">
      </div>
      <div class="text-version">
        {{ t('settings.version') }} {{ version }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useDialog } from '@/composables/useDialog'
import { useLoginDialog } from '@/composables/useLoginDialog'
import { showLoadingToast, showToast, closeToast } from '@/utils/toast'
import theme from '@/styles/theme'
import bridge from '@/utils/bridge'
import { version } from '../../../package.json'
import { logEventSafe } from '@/plugins/firebase'
import { useI18n } from 'vue-i18n'
import { useRandomArrayStore } from '@/stores/useRandomArrayStore'

const { t } = useI18n()
const router = useRouter()
const userStore = useUserStore()
const randomStore = useRandomArrayStore()
const dialog = useDialog()
const $loginDialog = useLoginDialog()
const isEditInfo = computed(() => userStore.getIsEditInfo())
const userData = computed(() => JSON.parse(localStorage.getItem('ai-chat-user') || '{}'))
const goEditProfile = () => {
  router.push({ name: 'EditProfile' })
}
// 这些变量将在clearCache函数中使用
const handleLogout = async () => {

  const confirmed = await dialog.confirm({
    title: t('settings.logOutTitle'),
    message: t('settings.logOutMessage'),
    confirmButtonText: t('common.confirm'),
    cancelButtonText: t('common.cancel'),
    confirmButtonColor: '#667eea'
  })
  if (confirmed) {
    bridge.call(randomStore.randomArray[2])
    // 先清除用户数据
    userStore.logOut()

    // 立即跳转到登录页面，避免路由守卫的检查循环
    $loginDialog.show()
  }
}
const goBack = () => {
  router.back()
}
/**
 * 处理discord
 */
 const handleDiscord = () => {
  showLoadingToast(t('dialog.processing'), { duration: 2000 })
  window.location.href = userData.value.contactUs || 'https://discord.gg/WNTyxU5mHk'
  setTimeout(() => {
    closeToast()
  }, 2000)
}
const goFAQ = () => {
  router.push({ name: 'FAQ' })
}
const openTerms = () => {
  router.push({ name: 'Terms' })
}
const openPrivacy = () => {
  router.push({ name: 'Policy' })
}
const handleAboutAccount = () => {
  router.push({ name: 'Account' })
}
const deleteAccount = async () => {
  try {
    const confirmed = await dialog.confirm({
      title: t('settings.deleteAccountTitle'),
      message: t('settings.deleteAccountMessage'),
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel'),
      confirmButtonColor: '#667eea'
    })

    if (confirmed) {
      try {
        showLoadingToast(t('settings.deletingAccount'))
        await userStore.deleteUser()
        showToast(t('settings.accountDeleted'), { type: 'success' })
        localStorage.removeItem('isNewUserLogin')
        localStorage.removeItem('first_pay_success_to_vippage')

        bridge.call(randomStore.randomArray[2])

        $loginDialog.show()
        // router.replace({ name: 'Login' })
      } catch (error) {
        console.log('User cancelled, error:', error)
      } finally {
        closeToast()
      }
    }
  } catch (error) {
    // 用户点击了取消或关闭
    console.log('User cancelled, error:', error)
  }
}
const clearCache = async () => {
  const confirmed = await dialog.confirm({
    title: t('settings.cacheTitle'),
    message: t('settings.cacheMessage'),
    confirmButtonText: t('common.confirm'),
    cancelButtonText: t('common.cancel'),
    confirmButtonColor: '#667eea'
  })
  if (confirmed) {
    logEventSafe('user_cache_cleaning')
    showLoadingToast(t('settings.cleaning'))
    // 🔧 备份重要数据（在清除缓存前备份）
    const token = userStore.getStoredToken()
    const appId = userStore.getAppId()
    const udid = userStore.getudid()

    // 调用app清除缓存
    // bridge.callApp('appClearTheCache')

    // 🔧 修复：跳转后立即显示toast
    setTimeout(() => {
      // 恢复重要数据
      if (token) userStore.setToken(token)
      if (appId) userStore.setAppId(appId)
      if (udid) userStore.setudid(udid)
      localStorage.setItem('isNewUserLogin', '1')
      // 先跳转到首页
      router.push({
        path: '/'
      })

      // 🔧 在跳转后立即显示成功提示（通过延时确保页面加载完成）
      setTimeout(() => {
        showToast(t('settings.cleaningComplete'), { type: 'success', duration: 2000 })
      }, 100)
    }, 500)
  }
}
</script>

<style scoped>
.settings-list {
  margin-top: 12px;

  .border-top{
    /* border-bottom: none !important; */
    border-radius: 12px 12px 0px 0px ;
  }
  .border-bottom-1{
    /* border-bottom: none !important; */
    border-radius: 0px 0px 12px 12px ;
  }
  .border-bottom{
    /* border-bottom: none !important; */
    border-radius: 12px;
    /* margin-bottom: -1px; */
  }
  .setting-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 0 14px;
    /* border-radius: 12px; */
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    margin-bottom: 10px;

    .left {
      display: flex;
      align-items: center;

      .icon {
        margin-right: 10px;
        width: 20px;
        text-align: center;
      }

      .text {
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
      }

      .dot {
        position: absolute;
        top: 0px;
        right: -6px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #ff4d8d;
      }
    }

    .arrow {
      color: v-bind('theme.colors.textPrimary');
      font-size: 18px;
    }
  }
}

.text-version {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}
</style>